import api from '../api';
import {
  ExamDetailsResponse,
  ExamByIdDetailsResponse,
  ExamDetails,
  CreateExamRequest,
  CreateExamResponse,
  ExamPayload,
  UpdateExamRequest,
  UpdateExamResponse,
  ExamSubjectDetailsResponse,
  PublishExamResponse,
  CompleteExamResponse,
  CancelExamResponse,
  IExamAcknowledgementParams,
  IExamAcknowledgementResponse,
} from '../../interface/examDetails.interface';

export const getExams = async (params?: ExamPayload): Promise<ExamDetailsResponse> => {
  const response = await api.get<ExamDetailsResponse>('/exam', { params });
  return response.data;
};

export const getExamById = async (id: string): Promise<ExamByIdDetailsResponse> => {
  const response = await api.get<ExamByIdDetailsResponse>(`exam/${id}`);
  return response.data;
};

export const addExam = async (payload: CreateExamRequest): Promise<CreateExamResponse> => {
  const response = await api.post<CreateExamResponse>('exam', payload);
  return response.data;
};

export const updateExam = async (
  examId: string,
  body: CreateExamRequest,
): Promise<UpdateExamResponse> => {
  const response = await api.patch<UpdateExamResponse>(`/exam/${examId}`, body);
  return response.data;
};

export const examPublish = async (examId: string): Promise<PublishExamResponse> => {
  const response = await api.patch<PublishExamResponse>(`/exam/${examId}/publish`);
  return response.data;
};

export const examRelease = async (examId: string): Promise<CompleteExamResponse> => {
  const response = await api.patch<CompleteExamResponse>(`/exam/${examId}/complete`);
  return response.data;
};

export const examCancel = async (examId: string): Promise<CancelExamResponse> => {
  const response = await api.patch<CancelExamResponse>(`/exam/${examId}/cancel`);
  return response.data;
};

export const getExamSubjectById = async (id: string): Promise<ExamSubjectDetailsResponse> => {
  const response = await api.get<ExamSubjectDetailsResponse>(`exam-subject/${id}`);
  return response.data;
};

export const getExamAcknowledgements = async (
  examId: string,
  params?: IExamAcknowledgementParams,
): Promise<IExamAcknowledgementResponse> => {
  const response = await api.get<IExamAcknowledgementResponse>(`/exam/${examId}/acknowledgement`, {
    params,
  });
  return response.data;
};
